const initailState = false;

const adminLoginError = (state = initailState, action) => {
  switch (action.type) {
    case "ADD_ADMIN_ERROR":
      return true;
    case "REMOVE_ADMIN_ERROR":
      return false;
    default:
      return state;
  }
};

export default adminLoginError;
